import React, { Component } from "react";
import { Col, Card, Form } from "antd";
import _ from "lodash";

class CustomerInformation extends Component {
  render() {
    const { newCar } = this.props;
    return newCar.id ? (
      <Col xs={24} md={12}>
        <Card title="Costumer Information">
          <Form.Item label="Nama Customer">
            <span className="ant-form-text form-text-mod">
              {newCar.customerName}
            </span>
          </Form.Item>
          <Form.Item label="No. Hp">
            <span className="ant-form-text form-text-mod">{newCar.phone}</span>
          </Form.Item>
        </Card>
      </Col>
    ) : null;
  }
}

export default CustomerInformation;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Section/CustomerInformation.js